import React from "react";
import { FaBuilding } from "react-icons/fa";
import "./AssetLabel.css";

export function isStockAsset(eventOrType) {
  const type = typeof eventOrType === "string"
    ? eventOrType
    : eventOrType?.assetType;
  return String(type || "").toUpperCase() === "STOCK";
}

export default function AssetLabel({
  symbol,
  event,
  assetType,
  className = "",
  markerClassName = "",
  iconOnly = false,
}) {
  const isStock = isStockAsset(assetType || event);
  const displaySymbol = symbol || event?.cur || event?.symbol || "";

  return (
    <span className={`assetLabel ${isStock ? "assetLabelStock" : ""} ${className}`.trim()}>
      {!iconOnly ? <span className="assetLabelText">{displaySymbol}</span> : null}
      {isStock ? (
        <span
          className={`assetStockMarker ${markerClassName}`.trim()}
          title="Stock"
          aria-label="Stock"
        >
          <FaBuilding aria-hidden="true" />
        </span>
      ) : null}
    </span>
  );
}
